import type { EstadoFichaLote, EstadoLotePartido } from '../services/api';

export const ESTADO_LOTE: Record<EstadoLotePartido, { etiqueta: string; clase: string; descripcion?: string }> = {
  BORRADOR: {
    etiqueta: 'Borrador · sin presentar',
    clase: 'badge-gray',
  },
  EN_ESPERA_SEP: {
    etiqueta: 'En espera de validación de la SEP',
    clase: 'badge-info',
    descripcion: 'La SEP está verificando las fichas en papel. Te vamos a avisar cuando termine. Mientras tanto, estas afiliaciones no figuran en tu registro.',
  },
  EN_SUBSANACION: {
    etiqueta: 'En subsanación',
    clase: 'badge-warning',
    descripcion: 'La SEP te intimó a acreditar la autenticidad de las fichas presentadas o a reemplazar las observadas. Revisá la notificación en el expediente.',
  },
  RESUELTO: {
    etiqueta: 'Resuelto',
    clase: 'badge-success',
    descripcion: 'La SEP terminó de verificar este lote.',
  },

  DESCARTADO: {
    etiqueta: 'Descartado',
    clase: 'badge-gray',
  },
};

export function numeroCorto(numero: string): string {
  return numero.split('-').pop() ?? numero;
}

export const RESULTADO_FICHA: Record<EstadoFichaLote, { etiqueta: string; clase: string }> = {
  PENDIENTE: { etiqueta: 'Sin resolver todavía', clase: 'badge-gray' },
  APROBADA: { etiqueta: 'Afiliación aprobada', clase: 'badge-success' },
  RECHAZADA: { etiqueta: 'Afiliación rechazada', clase: 'badge-danger' },
};